import { CopilotScript } from '@coach-bot/data-access/shared/models';
import { safeSentryCaptureException } from '@shared/sentry';
import { Services } from '../services';

export async function refreshCopilotScripts(services: Services): Promise<void> {
  console.info('Fetching copilot scripts from backend...');
  // LAMBDA-70797: Should be investigated before reenabled
  // const transaction = startTransaction({ name: 'getCopilotScripts' });
  // const span = transaction.startChild({
  //   op: 'getCopilotScripts',
  // });
  try {
    const copilotScripts:CopilotScript[] = await services.copilotScriptsService.getCopilotScriptsWithRetry();
    await services.commonStore.setCopilotScripts(copilotScripts);
    console.info('Copilot scripts fetched from backend.');
    // span.setStatus('ok');
  } catch (e) {
    console.error('Error while fetching copilot scripts from backend.', e);
    // span.setStatus('unknown_error');
    safeSentryCaptureException(e as Error);
  }
  // finally {
  //   span.finish();
  //   transaction.finish();
  // }
}
